// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OrderController_UpdateSignedOneById_Input_MarketType,
  MutationInput_OrderController_UpdateSignedOneById_Input_SettlementCondition,
  MutationInput_OrderController_UpdateSignedOneById_Input_TransactionVenue,
  UpdateSignedOrderByAdminDto_Input,
} from 'api/generated/graphql';
import { UpdateSignedOrderParams } from 'api/types/params';

export const parseUpdateSignedOrderParams = (
  versionNumber: number,
  params: UpdateSignedOrderParams
): UpdateSignedOrderByAdminDto_Input => ({
  versionNumber,
  settlementCondition: params.settlementCondition
    ? MutationInput_OrderController_UpdateSignedOneById_Input_SettlementCondition[
        params.settlementCondition
      ]
    : null,
  marketType: params.marketType
    ? MutationInput_OrderController_UpdateSignedOneById_Input_MarketType[
        params.marketType
      ]
    : undefined,
  transactionVenue: params.transactionVenue
    ? MutationInput_OrderController_UpdateSignedOneById_Input_TransactionVenue[
        params.transactionVenue
      ]
    : undefined,
  fmNumber: params.fmNumber,
  assignedEmployeeId: params.assignedEmployeeId,
  hasBrokerRecommendation: params.hasBrokerRecommendation,
  comment: params.comment,
  adminFileIds: params.adminFileIds,
});
